import ComparisonPage from './ComparisonPage';

export { ComparisonPage };
